<mbs-input
  [formControl]="control()"
  [id]="inputId()"
  [label]="label() | i18next"
  [name]="name()"
  [placeholder]="placeholder()"
  [showRequiredMark]="false"
  [disabledSelf]="disabledSelf()"
  [validationWhitespace]="requiredValidationEnabled() || pathValidationEnabled()"
  (buttonClick)="destinationFolderTreeOpen()"
  [appendButtons]="[{ text: browseText(), id: buttonId(), type: 'secondary', disabled: disabledSelf() }]"></mbs-input>
